import React from 'react';

const stringifyNumber = props => {
  const special = [
    'zeroth',
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
    'eleventh',
    'twelfth',
    'thirteenth',
    'fourteenth',
    'fifteenth',
    'sixteenth',
    'seventeenth',
    'eighteenth',
    'nineteenth'
  ];
  const deca = [
    'twent',
    'thirt',
    'fort',
    'fift',
    'sixt',
    'sevent',
    'eight',
    'ninet'
  ];
  let number = '';
  if (props.number < 20) {
    number = special[props.number];
  } else if (props.number % 10 === 0) {
    number = deca[Math.floor(props.number / 10) - 2] + 'ieth';
  } else {
    number =
      deca[Math.floor(props.number / 10) - 2] +
      'y-' +
      special[props.number % 10];
  }

  return (
    <span>
      {props.prefix}
      {number}
      {props.postfix}
    </span>
  );
};

export default stringifyNumber;



// WEBPACK FOOTER //
// ./src/components/StringifyNumber/StringifyNumber.jsx